/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
const statusConfig = {
  created: { label: 'Created', classes: 'badge badge-neutral text-neutral-content border-none' },
  opened: { label: 'Opened', classes: 'badge badge-info text-info-content font-bold' },
  in_progress: { label: 'In Progress', classes: 'badge badge-warning text-warning-content font-bold' },
  confirmation_pending: { label: 'Confirmation Pending', classes: 'badge badge-warning text-warning-content font-bold' },
  processing: { label: 'Processing', classes: 'badge badge-info text-info-content font-bold' },
  import_abort: { label: 'Import Aborted', classes: 'badge badge-error text-error-content font-bold' },
  completed: { label: 'Completed', classes: 'badge badge-success text-success-content font-bold' },
  expired: { label: 'Expired', classes: 'badge badge-error text-error-content font-bold' },
  active: { label: 'Active', classes: 'badge badge-success text-success-content font-bold' },
  invited: { label: 'Invited', classes: 'badge badge-info text-info-content font-bold' },
  inactive: { label: 'Inactive', classes: 'badge badge-neutral text-neutral-content border-none' }
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || { label: status, classes: 'badge badge-ghost' };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
